import type { ReactElement, ReactNode } from 'react';
import { Container, Stack } from '@mui/material';
import { ButtonGroup } from '@noah-labs/fe-shared-ui-components';
import type {
  MarkdownRemarkFrontmatterHeaderMenuHeaderLinks,
  Maybe,
} from '../../../generated/types';
import { DesktopMenu } from './DesktopMenu';
import { NavbarLogo } from './NavbarLogo';
import { ProgressBar } from './ProgressBar';

type PpDesktopHeader = {
  ButtonsSlot?: ReactNode;
  disableProgressBar?: boolean;
  menu: Maybe<Maybe<MarkdownRemarkFrontmatterHeaderMenuHeaderLinks>[]> | undefined;
  onEnter: (label: string) => void;
  onLeave: () => void;
  selectedMenu: string;
  withLanguageSwitch?: boolean;
};

export function DesktopHeader({
  ButtonsSlot,
  disableProgressBar,
  menu,
  onEnter,
  onLeave,
  selectedMenu,
  withLanguageSwitch,
}: PpDesktopHeader): ReactElement {
  return (
    <Container disableGutters fixed component="nav" maxWidth="lg" sx={{ py: 2 }}>
      <Stack direction="row" justifyContent="space-between">
        <NavbarLogo />
        <Stack direction="row" spacing={2}>
          <DesktopMenu
            menu={menu}
            selectedMenu={selectedMenu}
            withLanguageSwitch={withLanguageSwitch}
            onEnter={onEnter}
            onLeave={onLeave}
          />
          <ButtonGroup direction="row" height="fit-content" width="100%">
            {ButtonsSlot}
          </ButtonGroup>
        </Stack>
      </Stack>
      {!disableProgressBar && <ProgressBar fullWidthSeparator={!!selectedMenu} />}
    </Container>
  );
}
